(function () {
  function isVisibleRetailerWrapper(el) {
    if (!el || el.nodeType !== 1) {
      return false;
    }

    var style = window.getComputedStyle(el);
    return style.display !== 'none' && style.visibility !== 'hidden';
  }

  function closeRetailerWrappers(except) {
    var wrappers = document.querySelectorAll('.sc-btn-retailer-wrapper, div[id^="sc-rd"]');

    for (var i = 0; i < wrappers.length; i++) {
      var wrapper = wrappers[i];

      if (except && (wrapper === except || wrapper.contains(except))) {
        continue;
      }

      if (isVisibleRetailerWrapper(wrapper)) {
        wrapper.style.display = 'none';
      }
    }
  }

  function isInsideSmartButton(target) {
    if (!target || !target.closest) {
      return false;
    }

    return Boolean(
      target.closest('.sc-btn-retailer-wrapper') ||
        target.closest('div[id^="sc-rd"]') ||
        target.closest('[data-sc-type="SmartButton"]') ||
        target.closest('.sc-btn-ec')
    );
  }

  document.addEventListener(
    'click',
    function (event) {
      var target = event.target;

      if (isInsideSmartButton(target)) {
        return;
      }

      closeRetailerWrappers();
    },
    true
  );

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape' || event.keyCode === 27) {
      closeRetailerWrappers();
    }
  });
})();
